module.exports = __webpack_public_path__ + "resources/img/img_sqml_di1_m_jp.44b72d3b4e4016fe0ad5f6830fc35a2b.png";